module.exports = __webpack_public_path__ + "img/美团_02.db6d6620.jpg";